import React, { useRef } from 'react';

import usePluginEntities from 'hooks/usePluginEntities';
import type { EventActionComponentProps } from 'views/types';
import type { Event } from 'components/events/events/types';

const usePluggableSecurityEventActions = (events: Array<Event>, onlyBulk: boolean = false) => {
  const modalRefs = useRef({});
  const pluggableActions = usePluginEntities('views.components.securityEventActions');
  const availableActions = pluggableActions.filter(
    (perspective) =>
      (onlyBulk ? perspective.isBulk : true) && (perspective.useCondition ? !!perspective.useCondition(events) : true),
  );

  const actions = availableActions.map(
    ({
      component: PluggableEventAction,
      key,
    }: {
      component: React.ComponentType<EventActionComponentProps<unknown>>;
      key: string;
    }) => (
      <PluggableEventAction
        key={`event-action-${key}`}
        events={events}
        modalRef={() => modalRefs.current[key]}
        fromBulk={onlyBulk}
      />
    ),
  );

  const actionModals = availableActions
    .filter(({ modal }) => !!modal)
    .map(({ modal: ActionModal, key }) => (
      <ActionModal
        key={`event-action-modal-${key}`}
        events={events}
        ref={(r) => {
          modalRefs.current[key] = r;
        }}
        fromBulk={onlyBulk}
      />
    ));

  return { actions, actionModals };
};

export default usePluggableSecurityEventActions;
